import { memo } from 'react'
import Heading from '../../../../LuxKit/Typography/Heading'
import { getMonthName } from 'lib/datetime/dateUtils'

interface Props {
  currentDate: Date
}

function VerticalDatePickerHeader(props: Props) {
  const {
    currentDate,
  } = props

  return (
    <Heading variant="heading5">{getMonthName(currentDate)} {currentDate.getFullYear()}</Heading>
  )
}

export default memo(VerticalDatePickerHeader)
